import { Component, Input, OnInit } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: false
})
export class BreadcrumbsComponent implements OnInit {
  @Input() breadcrumb: any;
  @Input() currentCategory: any;
  @Input() catalogCode: string;
  @Input() catalogName: string;

  appStrings: AppLocalization;

  constructor(
    private appInfoService: AppInfoService,
  ) {
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
  }
}
